import React from 'react'
import NavBar from './NavBar'
// import Footer from './Footer'

const Profile = () => {
  return (
    <>
    <NavBar/>
    <div className='flex justify-center mt-32'>Profile page</div>
    {/* <Footer/> */}
    </>
  )}

export default Profile